/* esm.sh - applesauce-core@5.2.0/helpers/regexp */
export * from "/*applesauce-core@5.2.0/esnext/helpers/regexp.mjs";
